{
  "global.siteDescription": "Présentez-vous vraiment en 30 secondes, pour que l’on vous comprenne rapidement.",
  "global.languageSwitch": "Changer de langue",
  "global.languageCurrent": "Langue actuelle : {locale}",
  "global.language.zh-CN": "中文",
  "global.language.zh-TW": "繁體中文",
  "global.language.en": "English",
  "global.language.ja": "日本語",
  "global.language.ko": "한국어",
  "global.language.es": "Español",
  "global.language.fr": "Français",
  "global.language.de": "Deutsch",
  "global.language.pt-BR": "Português (Brasil)",
  "global.language.ru": "Русский",
  "global.language.ar": "العربية",
  "common.close": "Fermer",
  "common.cancel": "Annuler",
  "common.save": "Enregistrer",
  "common.delete": "Supprimer",
  "common.edit": "Modifier",
  "common.manage": "Gérer",
  "common.login": "Se connecter",
  "common.logout": "Se déconnecter",
  "common.loggingOut": "Déconnexion",
  "common.logoutRetry": "Réessayer la déconnexion",
  "common.preview": "Aperçu",
  "common.email": "Email",
  "common.inviteCode": "Code d'invitation",
  "common.loading": "Chargement",
  "editor.publish.processing": "Toujours en cours de traitement",
  "common.localDraft": "Brouillon local",
  "common.publicBeta": "Bêta publique",
  "common.serviceStatus": "Statut des services",
  "common.optional": "Facultatif",
  "common.page": "Page",
  "common.reason": "Raison",
  "common.description": "Détails",
  "common.submit": "Envoyer",
  "nav.login": "Se connecter",
  "nav.draftFirst": "Démarrer un brouillon",
  "home.action.create": "Créer ma présentation",
  "home.action.continue": "Continuer à écrire",
  "home.action.manage": "Gérer ma présentation",
  "home.action.agent": "L’Agent rédige",
  "home.meta.title": "30s.to — 30 secondes pour vous connaître.",
  "home.meta.description": "Quand on avance seul, se faire connaître compte encore plus. 30 secondes pour vous connaître. Qui vous êtes, ce que vous faites, ce que vous avez accompli et les ressources que vous pouvez proposer. Aidez les autres à découvrir ce qui les intéresse et à nouer des liens avec vous.",
  "home.title": "30 secondes\npour vous connaître.",
  "home.freeNote": "Créez, publiez et partagez. Gratuit pour toujours.",
  "home.kicker": "Quand on avance seul, se faire connaître compte encore plus.",
  "home.value.copy": "Qui vous êtes, ce que vous faites, ce que vous avez accompli et les ressources que vous pouvez proposer. Aidez les autres à découvrir ce qui les intéresse et à nouer des liens avec vous.",
  "home.features.label": "Fonctionnalités",
  "home.features.time.tab": "Lire en 30 secondes",
  "home.why.copy": "Écrivez seulement l’essentiel. Plus une présentation est longue, moins on la lit jusqu’au bout. 30 secondes, c’est juste ce qu’il faut.",
  "home.principle.expression.title": "Exprimez-vous",
  "home.principle.expression.copy": "Organisez votre parcours, vos réalisations, vos idées et vos ressources à votre façon. Partagez ce que vous souhaitez faire connaître de vous.",
  "home.principle.link.title": "Votre propre lien 30s.to",
  "home.principle.link.copy": "30s.to/@you est court, facile à retenir et va droit au but : vous découvrir en 30 secondes.",
  "home.principle.theme.title": "Des thèmes variés pour vous exprimer",
  "home.principle.theme.copy": "Épuré, rétro ou audacieux et coloré. Choisissez un thème qui vous ressemble pour faire sentir votre style dès le premier regard.",
  "home.footer.tagline": "Dites-en moins pour que l’essentiel ressorte.",
  "home.footer.navigation": "Navigation en pied de page",
  "home.demo.linkNotice": "Ceci est un lien de démonstration. Créez votre introduction de 30 secondes pour ajouter la vôtre.",
  "home.demo.profile.name": "Maya Chen",
  "home.demo.profile.identity": "Concepteur de produits indépendant transformant des problèmes complexes en produits simples",
  "home.demo.profile.tag.product": "Conception de produits",
  "home.demo.profile.tag.indie": "Produits indépendants",
  "home.demo.profile.tag.ai": "Outils AI",
  "home.demo.profile.body": "## En ce moment\nJe crée Briefly pour que les designers indépendants passent moins de temps à déplacer des notes et plus à comprendre les gens. Avant de concevoir, je parcours la tâche réelle avec un utilisateur.\n\n## Mon parcours\n2020–2023 : design de l’éditeur et de l’accueil des utilisateurs dans une équipe de logiciels collaboratifs. Avec les ingénieurs, j’ai décomposé les opérations complexes en étapes accessibles.\n\nDepuis 2024 : recherche et design d’interaction en indépendant pour de jeunes équipes, tout en développant mes produits.\n\n## Projets\n- [Relay](https://example.com/projects/relay) : j’ai conçu ce journal de décisions réunissant conclusions, raisons et responsables pour donner du contexte aux nouveaux membres.\n- [Briefly](https://example.com/projects/briefly) : en petit pilote, il organise les entretiens en thèmes traçables et conserve les citations pour vérifier les interprétations.\n\n## Ce que je partage\nVous avez des retours sans savoir quoi changer d’abord ? Je peux cadrer le problème et créer un prototype à tester. Je partage aussi guides d’entretien et modèles de notes avec les équipes débutant la recherche.\n\n## Parlons-en\nJ’aimerais parler de premiers entretiens, d’arbitrages et de travail indépendant avec des créateurs de petits produits soignés. Le week-end, j’explore les boutiques du quartier : un tarif manuscrit peut être une belle leçon de clarté.",
  "home.demo.profile.link.website": "Travail",
  "home.demo.profile.link.github": "GitHub",
  "home.demo.profile.link.calendar": "Réservez une conversation",
  "handleStart.kicker": "URL publique",
  "handleStart.title": "Choisissez votre URL 30s.to",
  "handleStart.copy": "Choisissez d’abord une URL facile à retenir, puis rédigez votre présentation de 30 secondes. Votre brouillon existant est conservé.",
  "handleStart.label": "Votre URL",
  "handleStart.help.empty": "4 à 24 lettres minuscules. Cela enregistre uniquement un brouillon ; la disponibilité est confirmée lors de la publication.",
  "handleStart.help.ok": "Le format semble bon. La disponibilité est à nouveau vérifiée lors de la publication.",
  "handleStart.submit": "Continuer à écrire",
  "handleAvailability.checking": "Vérification de cette URL…",
  "handleAvailability.available": "Disponible maintenant. Il devient le vôtre après une publication réussie.",
  "handleAvailability.owned": "Vous possédez déjà cette adresse.",
  "handleAvailability.assigned": "Cette adresse vous est attribuée et prend effet après publication.",
  "handleAvailability.failed": "Impossible de vérifier cette URL. Réessayez.",
  "handleAvailability.rateLimited": "Trop de vérifications. Réessayez dans {minutes} minutes.",
  "handleAvailability.retry": "Revérifier",
  "handleAvailability.suggestions": "Vous pouvez aussi essayer",
  "handleAvailability.cooldown": "Cette URL publique est encore soumise au délai de 30 jours. Vous pourrez la modifier après le {date}, ou rétablir l’URL actuellement publiée.",
  "editor.shell.loading": "Chargement créer un flux",
  "editor.shell.workspace": "Espace de travail d'introduction de 30 secondes",
  "editor.shell.canvas": "Surface d'écriture d'introduction de 30 secondes",
  "editor.command.aria": "Barre de commandes de l'éditeur",
  "editor.command.publish": "Publier",
  "editor.command.publishUpdate": "Publier les modifications",
  "editor.command.publishSettings": "Paramètres de publication",
  "editor.command.dashboard": "Dashboard",
  "editor.publish.success": "Publié",
  "editor.publish.successAfterLogin": "Connecté et publié",
  "editor.publish.publishing": "Publication…",
  "editor.publish.publishingDetail": "Nous préparons votre page publique. Un instant, s’il vous plaît.",
  "editor.publish.successDetail": "Votre page publique est à jour et prête à être consultée.",
  "editor.publish.viewPublic": "Voir la page publique",
  "editor.publish.cacheFailed": "mais l'écriture du cache des pages publiques a échoué.",
  "editor.command.login": "Se connecter",
  "editor.handle.editTitle": "Modifier l'adresse publique",
  "editor.handle.claimAfterPublish": "Le vôtre après la publication",
  "editor.handle.claimAfterPublishTitle": "Cette adresse devient la vôtre après publication",
  "editor.status.signedIn": "Connecté",
  "editor.status.account": "Compte : {email}",
  "editor.status.localTitle": "Projet local",
  "editor.status.localCopy": "Ce brouillon est uniquement enregistré sur cet appareil. Connectez-vous pour le synchroniser avec le cloud.",
  "editor.status.location": "Enregistrer l'emplacement",
  "editor.status.state": "Enregistrer le statut",
  "editor.status.emailLogin": "Connexion Email",
  "editor.autosave.savingShort": "Enregistrement",
  "editor.autosave.savedCloudShort": "Enregistré dans le cloud",
  "editor.autosave.savedLocalShort": "Enregistré localement",
  "editor.autosave.failedShort": "Échec de l'enregistrement",
  "editor.autosave.signedInShort": "Connecté",
  "editor.autosave.cloud": "Nuage",
  "editor.autosave.retry": "Il faut réessayer",
  "editor.autosave.device": "Cet appareil",
  "editor.autosave.saving": "Sauvegarde automatique...",
  "editor.autosave.savedLocal": "Enregistré automatiquement localement",
  "editor.autosave.savedCloud": "Enregistré automatiquement dans le cloud",
  "editor.autosave.authExpired": "Session expirée. Enregistré localement.",
  "editor.autosave.cloudFailed": "La sauvegarde dans le cloud a échoué. Enregistré localement.",
  "editor.autosave.cloudUnavailable": "La sauvegarde dans le cloud n'est pas encore connectée. Enregistré localement.",
  "editor.autosave.failed": "L'enregistrement automatique a échoué. Copiez votre contenu et réessayez.",
  "editor.autosave.enabled": "La sauvegarde automatique est activée",
  "identity.namePlaceholder": "Votre nom",
  "identity.nameAria": "Nom ou surnom",
  "identity.identityPlaceholder": "Identité sur une seule ligne",
  "identity.identityAria": "Identité sur une seule ligne",
  "identity.tagsAria": "Balises",
  "identity.addTag": "Ajouter une balise",
  "identity.removeTag": "Supprimer le tag {tag}",
  "body.emptyInstruction": "Écrivez ce qu’une personne devrait surtout retenir en vous découvrant.\nÉcrivez moins pour que l’essentiel soit vu. 30 secondes, juste ce qu’il faut.",
  "body.templatesLabel": "Vous pouvez aussi partir d’un modèle",
  "body.templatesAria": "Modèles de profil pour le texte",
  "body.templateExampleLabel": "Profil d’exemple",
  "body.viewTemplateExample": "Voir l’exemple",
  "links.sectionAria": "Links",
  "links.documentTitle": "Links",
  "links.documentCopy": "Profils sociaux, réservation et coordonnées",
  "links.documentEmptyCopy": "Ajoutez un profil social, une page de réservation ou une méthode de contact. Vous pouvez les modifier à tout moment.",
  "links.add": "Ajouter un lien",
  "links.addType": "Ajouter {label}",
  "links.edit": "Modifier {label}",
  "links.addedAria": "Liens ajoutés",
  "links.closePanel": "Fermer l'éditeur de liens",
  "links.editTitle": "Modifier le lien",
  "links.addTitle": "Ajouter un lien",
  "links.chooseTypeAgain": "Choisissez à nouveau le type de lien",
  "links.calendarProvider": "Fournisseur de réservation",
  "links.displayName": "Nom d'affichage",
  "links.duplicate": "{label} a déjà été ajouté.",
  "links.alreadyAdded": "{label} déjà ajouté",
  "links.bookingAlreadyAdded": "La réservation a déjà été ajoutée",
  "links.remove": "Supprimer",
  "links.category.social": "Sociale",
  "links.category.booking": "Réservation",
  "links.category.work": "Réalisations / sites web",
  "links.category.content": "Contenu",
  "links.category.contact": "Contact",
  "links.category.other": "Autre",
  "links.type.x": "X",
  "links.type.github": "GitHub",
  "links.type.linkedin": "LinkedIn",
  "links.type.instagram": "Instagram",
  "links.type.youtube": "YouTube",
  "links.type.bilibili": "Bilibili",
  "links.type.xiaohongshu": "Xiaohongshu",
  "links.type.wechat": "Compte officiel WeChat",
  "links.type.email": "Email",
  "links.type.calendar": "Réservation",
  "links.type.website": "Site web",
  "links.type.newsletter": "Newsletter",
  "links.type.tiktok": "TikTok",
  "links.type.threads": "Threads",
  "links.type.mastodon": "Mastodon",
  "links.type.dribbble": "Dribbble",
  "links.type.jike": "Jike",
  "links.type.other": "Autre",
  "links.input.x": "Poignée en X",
  "links.input.github": "Poignée GitHub",
  "links.input.linkedin": "LinkedIn URL",
  "links.input.instagram": "Poignée Instagram",
  "links.input.youtube": "Poignée YouTube",
  "links.input.bilibili": "Bilibili UID",
  "links.input.xiaohongshu": "Profil Xiaohongshu URL",
  "links.input.wechat": "Identifiant du compte officiel WeChat",
  "links.input.email": "Email",
  "links.input.calendar": "Parcours de réservation",
  "links.input.website": "Website URL",
  "links.input.newsletter": "Newsletter URL",
  "links.input.tiktok": "Poignée TikTok",
  "links.input.threads": "Poignée Threads",
  "links.input.mastodon": "Mastodon URL",
  "links.input.dribbble": "Poignée Dribbble",
  "links.input.jike": "Profil Jike URL",
  "links.input.other": "Lien URL",
  "links.input.calendar.cal": "Chemin Cal.com",
  "links.input.calendar.calendly": "Chemin calme",
  "links.input.calendar.google": "Page de réservation Google Calendar",
  "links.input.calendar.microsoft": "Lien Microsoft Bookings",
  "links.input.calendar.hubspot": "Lien HubSpot Meetings",
  "links.input.calendar.savvycal": "Chemin SavvyCal",
  "links.input.calendar.tidycal": "Chemin TidyCal",
  "links.input.calendar.zcal": "chemin zcal",
  "links.hint.handle": "Entrez uniquement le handle, pas un URL.",
  "links.hint.uid": "Entrez uniquement le UID, pas le profil URL.",
  "links.hint.slug": "Entrez uniquement le chemin, pas le URL complet.",
  "links.hint.email": "Cela crée un lien mailto.",
  "links.hint.text": "Cliquer sur la page publique copie cette valeur.",
  "links.hint.url": "Entrez un lien https:// valide pour cette plateforme.",
  "links.hint.calendarSlug": "Entrez uniquement le nom d'utilisateur ou le chemin de réservation, pas le URL complet.",
  "links.hint.calendarUrl": "Entrez la page de réservation complète URL pour cette plateforme.",
  "rich.toolbarAria": "Barre d'outils de mise en forme du texte",
  "rich.heading": "Titre de section",
  "rich.paragraph": "Paragraphe",
  "rich.bold": "Audacieux",
  "rich.boldFallback": "texte en gras",
  "rich.italic": "Italique",
  "rich.italicFallback": "texte en italique",
  "rich.code": "Code en ligne",
  "rich.comment": "Activer ou retirer le commentaire",
  "rich.ul": "Liste à puces",
  "rich.ol": "Liste numérotée",
  "rich.link": "Lien",
  "rich.linkPrompt": "Entrez un lien https:// ou mailto:",
  "rich.linkInvalid": "Les liens prennent uniquement en charge https:// ou mailto :",
  "rich.linkFallback": "texte du lien",
  "rich.aria": "Corps d'introduction de 30 secondes",
  "rich.more": "Plus de formats",
  "rich.quote": "Citation",
  "rich.strikethrough": "Barré",
  "rich.strikethroughFallback": "texte barré",
  "rich.codeBlock": "Bloc de code",
  "rich.codeBlockFallback": "code",
  "rich.taskList": "Liste de tâches",
  "rich.table": "Tableau",
  "rich.tableSkeleton": "| Élément | Description |\n| --- | --- |\n| Élément un | Description un |\n| Élément deux | Description deux |",
  "rich.indent": "Augmenter le retrait",
  "rich.outdent": "Réduire le retrait",
  "rich.placeholder": "Écrivez une intro Markdown qui peut être lue en 30 secondes...",
  "feedback.aria": "Rédiger des commentaires",
  "feedback.timeTitle": "Temps de lecture estimé",
  "feedback.preview": "Aperçu",
  "feedback.previewMenu": "Ouvrir le menu d'aperçu",
  "feedback.openAcceptancePreview": "Aperçu de l'acceptation ouverte",
  "feedback.acceptancePreviewCopy": "Afficher le résultat de la page publique sur cet appareil",
  "feedback.noIssues": "Aucun problème de blocage",
  "feedback.prePublish": "Vérifications de pré-publication",
  "feedback.ready": "Aucun bloqueur",
  "feedback.itemCount": "Articles {count}",
  "feedback.valid": "Le contenu réussit les contrôles de publication.",
  "issue.action.displayName": "Ajouter un nom",
  "issue.action.oneLineIdentity": "Ajouter une identité",
  "issue.action.tags": "Ajouter des balises",
  "issue.action.body": "Retour au texte",
  "issue.action.handle": "Choisissez l'adresse",
  "issue.action.links": "Gérer les liens",
  "issue.action.view": "Voir",
  "issue.short.displayName": "Nom manquant",
  "issue.short.oneLineIdentity": "Identité manquante",
  "issue.short.tags": "Balises manquantes",
  "issue.short.handle": "Adresse manquante",
  "issue.short.readingTime": "Plus de 60 s",
  "issue.short.readingTimeLong": "Plus de 30 s",
  "issue.short.readingTimeShort": "Trop peu de contenu",
  "issue.short.bodyPlaceholder": "Contenu d'exemple dans le texte",
  "issue.short.bodyFormat": "Format du texte",
  "issue.short.links": "Problème de lien",
  "issue.short.linksEmpty": "Des liens peuvent être ajoutés",
  "issue.short.pending": "A besoin de travail",
  "issue.summary.more": "Éléments {count} à corriger",
  "publish.title.create": "Confirmer la publication",
  "publish.title.update": "Confirmer les modifications",
  "publish.action.create": "Publier sur 30s.to",
  "publish.action.update": "Publier les modifications",
  "publish.closeAria": "Fermer la confirmation de publication",
  "publish.address": "Sonorisation",
  "publish.unpublishedChanges": "Modifications non publiées",
  "publish.handleChanged": "Votre adresse passera de @{oldHandle} à @{newHandle}. L’ancienne redirigera pendant 30 jours. Après 180 jours à compter du changement, elle pourra être attribuée à une autre personne et les anciens liens pourront afficher son profil.",
  "publish.readingTime": "Temps de lecture",
  "publish.status": "Statut",
  "publish.ready": "Prêt",
  "publish.todo": "Éléments {count} à améliorer",
  "publish.visibility": "Mode de publication",
  "publish.visibility.indexed": "Autoriser l’indexation",
  "publish.visibility.unlisted": "Accessible par lien",
  "publish.visibility.indexedNote": "Tout le monde peut la consulter et elle peut apparaître dans les résultats de recherche.",
  "publish.visibility.unlistedNote": "Toute personne ayant le lien peut la consulter ; nous ne la soumettons pas aux moteurs de recherche.",
  "publish.visibility.publicNote": "Les deux options sont publiques et le lien peut être transféré. Gardez un brouillon si vous seul devez le voir.",
  "publish.publicContent": "La publication rend publics votre nom, identité, tags, texte et liens. Les commentaires d’auteur restent masqués, mais ne doivent pas contenir de secrets.",
  "publish.noop": "La page publique est déjà à jour. Modifiez le contenu ou la visibilité avant de publier à nouveau.",
  "publish.valid": "Le contenu réussit les contrôles de publication.",
  "handleEdit.title": "Modifier l'adresse publique",
  "handleEdit.label": "Adresse 30s.to",
  "handleEdit.help.changed": "L’enregistrement modifie uniquement le brouillon. Après publication, l’ancienne adresse redirigera pendant 30 jours et pourra être réattribuée après 180 jours.",
  "handleEdit.help.saved": "Enregistré dans le brouillon. La disponibilité est à nouveau vérifiée lors de la publication.",
  "handleEdit.note": "L'adresse publique actuelle est toujours 30s.to/@{handle}. La nouvelle adresse prend effet après la publication.",
  "handleEdit.save": "Enregistrer dans le brouillon",
  "conflict.title": "Choisir la version brouillon",
  "conflict.copy": "Cet appareil et le cloud ont tous deux du contenu inédit. Votre choix devient la prochaine version à modifier.",
  "conflict.useLocal": "Utiliser le brouillon local",
  "conflict.useLocalCopy": "Conservez le contenu actuel de la page et synchronisez-le avec le cloud.",
  "conflict.useCloud": "Utiliser le brouillon cloud",
  "conflict.untitled": "Sans titre",
  "conflict.cloudVersion": "Version enregistrée dans le cloud",
  "conflict.modifiedAt": "Dernière modification · {time}",
  "conflict.time.justNow": "à l’instant",
  "conflict.time.minutesAgo": "il y a {count} min",
  "conflict.time.hoursAgo": "il y a {count} h",
  "conflict.time.daysAgo": "il y a {count} j",
  "authModal.title": "Connectez-vous à 30s.to",
  "authModal.copy": "Après la connexion, les brouillons sont synchronisés avec le cloud et la publication est plus fiable.",
  "login.page.eyebrow": "Compte",
  "login.page.title": "Connectez-vous à 30s.to",
  "login.page.copy": "Synchronisez les brouillons, publiez des pages publiques et gérez les invitations.",
  "login.invalidEmail": "Entrez un email valide.",
  "login.sendFailed": "Impossible d'envoyer le code.",
  "login.devCodeReady": "Code de développement local généré.",
  "login.codeSent": "Code envoyé. Vérifiez votre courrier électronique.",
  "login.networkSendFailed": "Impossible d'envoyer le code. Vérifiez votre connexion.",
  "login.invalidCode": "Entrez le code à 6 chiffres.",
  "login.codeInvalid": "Le code est erroné ou expiré.",
  "login.failed": "La connexion a échoué. Réessayez plus tard.",
  "login.sendBusy": "Envoi...",
  "login.resendCode": "Renvoyer le code",
  "login.sendCode": "Envoyer le code",
  "login.localCode": "Code de développement local : {code}",
  "login.code": "Code",
  "login.codePlaceholder": "6 chiffres",
  "login.inviteHelp": "La bêta publique nécessite un code d'invitation. La vérification active votre compte.",
  "login.verifyBusy": "Vérification...",
  "login.verifyInvite": "Vérifier l'invitation et se connecter",
  "login.verify": "Connectez-vous et continuez",
  "login.footnote": "Connexion sans mot de passe. Les nouveaux utilisateurs s'activent avec une invitation après vérification par e-mail.",
  "login.google": "Continuer avec Google",
  "login.github": "Continuer avec GitHub",
  "login.emailDivider": "ou utilisez le courrier électronique",
  "login.oauthFailed": "La connexion sociale n'est pas terminée. Réessayez ou utilisez la connexion par e-mail.",
  "login.linkTitle": "Vérifier l'adresse e-mail du compte",
  "login.linkPageCopy": "Un compte 30s.to utilise déjà cette adresse e-mail. Nous ne le lions qu'après vérification ; les comptes ne sont jamais fusionnés automatiquement.",
  "login.linkCopy": "Nous enverrons un code à {email}. L'e-mail ne peut pas être modifié ici.",
  "login.linkVerify": "Vérifier et lier",
  "login.linkRequired": "Un compte existant a été trouvé. Vérifiez son email pour continuer.",
  "login.activateTitle": "Activer 30s.to",
  "login.activatePageCopy": "Votre identité sociale est vérifiée. Aucun compte permanent n'est créé tant que l'invitation n'a pas réussi.",
  "login.activateCopy": "La version bêta publique nécessite une invitation. Il n'est utilisé que lorsque la création du compte réussit.",
  "login.activationOpenCopy": "Les inscriptions sont ouvertes. Continuez pour activer votre compte.",
  "login.activationClosedCopy": "L’activation des nouveaux comptes est suspendue. Les comptes existants peuvent toujours se connecter.",
  "login.activate": "Activer et continuer",
  "login.inviteRequired": "Email vérifié. Utilisez une invitation pour l’activer.",
  "login.useEmailInstead": "Utilisez plutôt la connexion par e-mail",
  "preview.emptyEyebrow": "Aperçu",
  "preview.emptyTitle": "Aucune introduction disponible pour prévisualiser.",
  "preview.backToEdit": "Retour à modifier",
  "preview.edit": "Modifier",
  "preview.localNoteAria": "Remarque d'aperçu local",
  "preview.localNote": "Acceptation locale",
  "preview.localTitle": "Aperçu du brouillon sur cet appareil",
  "preview.themePicker": "Sélecteur de thème",
  "preview.themeGroup": "Choisir un thème",
  "preview.themeFree": "Base",
  "preview.themePro": "Pro",
  "preview.mobileAria": "Aperçu de la page publique mobile",
  "preview.close": "Fermer l'aperçu",
  "preview.editorTitle": "Aperçu",
  "preview.publicTitle": "Aperçu de la page publique",
  "preview.shareCardButton": "Voir la fiche thème",
  "preview.shareCardDialogTitle": "Aperçu de la carte thématique",
  "preview.shareCardTitle": "Carte thème {theme}",
  "preview.shareCardLogin": "Connectez-vous pour afficher l'aperçu réel",
  "preview.shareCardLoading": "Rendu de la carte thème…",
  "preview.shareCardError": "L'aperçu de la carte est temporairement indisponible",
  "preview.shareCardNote": "La carte thématique utilise le même langage visuel que la page publique. Les cartes universelles sont disponibles en Dashboard.",
  "public.copySuccess": "Copié {label}",
  "public.copyFailed": "La copie a échoué. Veuillez copier manuellement.",
  "public.createMine": "Créer mon introduction",
  "public.report": "Signaler cette page",
  "public.ownerAria": "Entrée de gestion personnelle",
  "public.owner.manage": "Gérer",
  "public.owner.edit": "Modifier",
  "public.status.unavailable": "Indisponible",
  "public.status.notFound": "404",
  "public.status.moderated": "Cette introduction de 30 secondes n'est pas disponible.",
  "public.status.frozen": "Cette adresse publique n'est pas disponible.",
  "public.status.unpublished": "Cette introduction de 30 secondes n'a pas encore été publiée.",
  "theme.footer": "Fabriqué avec 30s.to",
  "theme.fallback.name": "Votre nom",
  "theme.fallback.nameUpper": "VOTRE NOM",
  "theme.fallback.nameNoir": "Nom",
  "theme.fallback.nameIndex": "John Doe",
  "theme.fallback.identity": "Que fais-tu?",
  "theme.fallback.identityUpper": "VOTRE IDENTITÉ ET VOTRE MISSION UNIQUE",
  "theme.fallback.identityIndex": "Inconnu",
  "theme.fallback.identityNoir": "Identité",
  "theme.fallback.terminalName": "invité",
  "theme.fallback.terminalIntro": "Pas encore de courte introduction",
  "theme.terminal.commandLabel": "Commande de terminal",
  "theme.terminal.commandSubmit": "Exécuter la commande",
  "theme.terminal.outputLabel": "Sortie du terminal interactif",
  "theme.connect": "CONNECTER",
  "theme.markdown.tableRegion": "Tableau du contenu, défilement horizontal",
  "theme.markdown.task": "Tâche",
  "theme.tags": "ÉTIQUETTES",
  "theme.verified": "VÉRIFIÉ",
  "theme.name": "NOM",
  "theme.identityLabel": "IDENTITÉ",
  "theme.keywords": "MOTS CLÉS",
  "theme.scroll": "Rouleau",
  "theme.pixel.previous": "Écran précédent",
  "theme.pixel.next": "Écran suivant",
  "theme.pixel.screen": "Écran {current} de {total}",
  "theme.arcade.stage": "Scène {current} / {total}",
  "theme.noise.reseed": "Bruit de réensemencement",
  "theme.readingTime": "{seconds} s de lecture",
  "theme.readingUnit": "s de lecture",
  "theme.letter.greeting": "Bonjour,",
  "theme.letter.signoff": "Bien à vous,",
  "theme.letter.postscript": "Vous pouvez me trouver ici",
  "theme.letter.written": "Écrit le {date}",
  "dashboard.loginTitle": "Connectez-vous pour gérer votre introduction.",
  "dashboard.loginAction": "Connectez-vous et gérez",
  "dashboard.bannedTitle": "Ce compte est actuellement indisponible.",
  "dashboard.bannedCopy": "Si vous pensez qu'il s'agit d'une erreur, contactez-nous via l'entrée de rapport et d'appel.",
  "connections.kicker": "Compte",
  "connections.title": "Méthodes de connexion",
  "connections.settingsKicker": "Paramètres",
  "connections.settingsTitle": "Compte et connexions",
  "connections.settingsCopy": "Gérez les identités de connexion et les accès des Agents tiers.",
  "connections.backToDashboard": "Retour au tableau de bord",
  "connections.emailCode": "Code de vérification par e-mail",
  "connections.alwaysAvailable": "Toujours disponible",
  "connections.connect": "Connecter",
  "connections.disconnect": "Supprimer le lien 30s.to",
  "connections.notConnected": "Non connecté",
  "connections.noEmail": "Aucun email fourni",
  "connections.emailVerified": "Email vérifié",
  "connections.connected": "Connecté",
  "connections.unavailable": "Non activé",
  "connections.confirm": "Supprimer le lien {provider} de 30s.to ? La connexion Email reste disponible.",
  "connections.removed": "Le lien d'identité a été supprimé de 30s.to.",
  "connections.failed": "Impossible de mettre à jour les méthodes de connexion. Réessayez plus tard.",
  "connections.help": "Cela supprime uniquement le mappage d'identité 30s.to ; il ne révoque pas l'accès du fournisseur. Gérer l'accès du fournisseur :",
  "agentConnections.kicker": "Agent",
  "agentConnections.title": "Connexions Agent",
  "agentConnections.copy": "Installez une seule Skill pour que vos Agents habituels recueillent des informations, rédigent et mettent à jour votre brouillon 30s.to en toute sécurité.",
  "agentConnections.addTitle": "Connecter un nouvel Agent",
  "agentConnections.addCopy": "Voir l’URL de connexion et les étapes de configuration",
  "agentConnections.examplesDisclosure": "Voir des exemples d’utilisation",
  "settings.title": "Paramètres",
  "settings.copy": "Gérez votre compte, la sécurité, les connexions externes et votre offre 30s.to.",
  "settings.navAria": "Catégories de paramètres",
  "settings.account.title": "Compte",
  "settings.account.copy": "Votre identité 30s.to et l’accès à votre profil.",
  "settings.account.email": "E-mail du compte",
  "settings.account.profile": "Profil",
  "settings.account.plan": "Offre actuelle",
  "settings.account.manageProfile": "Gérer le profil",
  "settings.login.copy": "Gérez les identités utilisables pour vous connecter à 30s.to.",
  "settings.billing.copy": "Consultez votre offre actuelle, son renouvellement et l’accès à la facturation.",
  "settings.invites.copy": "Gérez votre quota d’invitations Public Beta et les codes récents.",
  "agentConnections.endpoint": "URL de connexion",
  "agentConnections.copyAction": "Copier",
  "agentConnections.copied": "Copié",
  "agentConnections.copyFailed": "Impossible de copier. Copiez l’URL manuellement.",
  "agentConnections.endpointCopied": "URL de connexion copiée.",
  "agentConnections.stepsAria": "Étapes de connexion d’un Agent",
  "agentConnections.step1": "Ajoutez un service distant dans les réglages MCP ou de connecteurs de votre Agent.",
  "agentConnections.step2": "Collez l’URL de connexion, connectez-vous à 30s.to et autorisez l’accès.",
  "agentConnections.step3": "Indiquez à l’Agent les modifications à effectuer, puis revenez sur 30s.to pour relire le brouillon.",
  "agentConnections.examplesTitle": "Exemples de demandes",
  "agentConnections.exampleFirst": "Lis mon profil 30s.to et ses règles de mise en forme, puis aide-moi à terminer ma première présentation.",
  "agentConnections.exampleSection": "Conserve mon ton et réécris uniquement la section « En ce moment ».",
  "agentConnections.exampleShorten": "Raccourcis toute la présentation pour qu’elle se lise en moins de 30 secondes. Ne la publie pas.",
  "agentConnections.copyExample": "Copier l’exemple {number}",
  "agentConnections.promptCopied": "Exemple de demande copié.",
  "agentConnections.boundary": "Les Agents peuvent uniquement lire et modifier les brouillons. Ils ne peuvent ni publier ni arrêter la publication à votre place.",
  "agentConnections.authorizedTitle": "Connexions autorisées",
  "agentConnections.empty": "Aucun Agent n’a encore été autorisé.",
  "agentConnections.disabled": "Les connexions Agent ne sont pas encore activées.",
  "agentConnections.scopeRead": "Lire le brouillon",
  "agentConnections.scopeWrite": "Modifier le brouillon",
  "agentConnections.connectedAt": "Connecté le {date}",
  "agentConnections.selfReported": "Le nom du client est déclaré par le client",
  "agentConnections.revoke": "Révoquer",
  "agentConnections.confirm": "Révoquer la connexion à {client} ? Ce client ne pourra plus accéder à votre brouillon 30s.to.",
  "agentConnections.confirmSkill": "Révoquer la connexion de la Skill 30s.to ? Les Agents locaux qui utilisent cette Skill seront déconnectés de 30s.to.",
  "agentConnections.revoked": "Connexion Agent révoquée.",
  "agentConnections.failed": "Impossible de mettre à jour les connexions Agent. Réessayez plus tard.",
  "agentConnections.manualTitle": "Connecter Remote MCP manuellement",
  "agentConnections.manualCopy": "Option avancée : autoriser séparément un client compatible Remote MCP",
  "skill.meta.title": "30s.to Skill — Laissez votre Agent écrire votre présentation",
  "skill.meta.description": "Partagez votre site, vos projets ou votre portfolio. Agent étudie votre travail et vous interviewe pour rédiger votre présentation de 30 secondes.",
  "skill.kicker": "30s.to Skill",
  "skill.title": "Votre présentation,\navec votre agent.",
  "skill.copy": "Donnez-lui quelques liens. Il apprend à vous connaître et vous aide à rédiger une présentation à lire en 30 secondes.",
  "skill.processTitle": "Comment l’Agent vous aide à écrire",
  "skill.process.clues.title": "Partagez des liens",
  "skill.process.clues.copy": "Votre profil public, le site de votre projet ou votre portfolio.",
  "skill.process.research.title": "Recherche approfondie, puis entretien",
  "skill.process.research.copy": "Il étudie en détail votre site, vos projets et vos réalisations, en dégage l’essentiel, puis vous interroge pour compléter ce que les documents ne disent pas.",
  "skill.process.profile.title": "Agent rédige votre présentation",
  "skill.process.profile.copy": "Ajustez ensemble le contenu et le ton pour obtenir une présentation qui vous ressemble.",
  "skill.installTitle": "Installez-la dans votre Agent",
  "skill.installCopy": "Copiez la consigne, collez-la dans votre agent habituel et envoyez-la.",
  "skill.promptLabel": "Instruction d’installation",
  "skill.copyPrompt": "Copier l’instruction d’installation",
  "skill.promptCopied": "Instruction d’installation copiée. Ouvrez maintenant l’Agent que vous utilisez, collez l’instruction et envoyez-la.",
  "skill.copyFailed": "Impossible de copier. Sélectionnez et copiez l’instruction d’installation ci-dessous.",
  "skill.startTitle": "Comment commencer",
  "skill.start.install": "Installer la Skill 30s.to",
  "skill.start.chat": "Commencer à discuter",
  "skill.start.chatCopy": "Une fois la Skill installée, ouvrez une nouvelle conversation et dites :",
  "skill.start.prompt": "Aide-moi à rédiger ma présentation avec 30s.to.",
  "dashboard.kicker": "Mon introduction",
  "dashboard.defaultTitle": "Mon introduction de 30 secondes",
  "dashboard.primaryEdit": "Continuer la modification",
  "dashboard.primaryCreate": "Commencez à créer",
  "dashboard.unpublished": "Non publié",
  "dashboard.unselected": "Non sélectionné",
  "dashboard.confirmDiscard": "Supprimer les modifications non publiées et restaurer la version publique actuelle ?",
  "dashboard.discardFailed": "Impossible d'ignorer les modifications.",
  "dashboard.discardConflict": "Ce brouillon a été modifié ailleurs. Actualisez la page et vérifiez-le avant de réessayer.",
  "dashboard.discardNetworkFailed": "Impossible d'ignorer les modifications. Réessayez plus tard.",
  "dashboard.discardDone": "Restauré à la version publique actuelle.",
  "dashboard.statusAria": "Statut actuel",
  "dashboard.versionAria": "Relation de version",
  "dashboard.publicPage": "Page publique",
  "dashboard.indexingAllowed": "Indexation autorisée",
  "dashboard.indexingBlocked": "Accessible par lien",
  "dashboard.publicVersion": "Version publiée",
  "dashboard.invisible": "Pas encore visible par les autres",
  "dashboard.draft": "Brouillon",
  "dashboard.currentDraft": "Version modifiable actuelle",
  "dashboard.draftSynced": "Synchronisé avec la page publique",
  "dashboard.editableVersionEmpty": "Version modifiable · Non créé",
  "dashboard.editableVersionDirty": "Version modifiable · Modifications non publiées",
  "dashboard.editableVersionSynced": "Version modifiable · Correspond à la page publique",
  "dashboard.editableVersionUnpublished": "Version modifiable · Non publié",
  "dashboard.betaActive": "Actif",
  "dashboard.betaInactive": "Inactif",
  "dashboard.adminCanPublish": "Le compte administrateur peut publier",
  "dashboard.betaAccessNote": "Accès à la publication bêta publique",
  "dashboard.visibility": "Visibilité",
  "dashboard.chooseOnPublish": "Choisir lors de la confirmation de publication",
  "dashboard.snapshot": "Instantané",
  "dashboard.snapshotAfterPublish": "Un instantané de la page publique est généré après la publication",
  "dashboard.publishDetailsAria": "Détails de publication",
  "dashboard.actionsAria": "Actions de gestion",
  "dashboard.nextAction": "Étape suivante",
  "dashboard.openPublicPage": "Ouvrir la page publique",
  "dashboard.changeVisibility": "Modifier le mode de publication",
  "dashboard.unpublish": "Arrêter la publication",
  "dashboard.unpublishTitle": "Arrêter la publication ?",
  "dashboard.unpublishDescription": "La page publique deviendra immédiatement indisponible. Le brouillon et l’adresse publique seront conservés pour une nouvelle publication.",
  "dashboard.unpublishWarning": "Les copies déjà enregistrées par des moteurs de recherche ou d’autres personnes peuvent ne pas disparaître immédiatement.",
  "dashboard.unpublishConfirm": "Arrêter la publication",
  "dashboard.unpublishBusy": "Arrêt en cours...",
  "dashboard.unpublishSuccess": "La page publique n’est plus disponible. Le brouillon et l’adresse publique ont été conservés.",
  "dashboard.unpublishFailed": "Impossible d’arrêter la publication. Réessayez plus tard.",
  "dashboard.discardBusy": "Restauration...",
  "dashboard.discard": "Ignorer les modifications",
  "dashboard.metricsAria": "Données légères",
  "dashboard.views": "Vues",
  "dashboard.clicks": "Clics",
  "dashboard.readingTime": "Temps de lecture",
  "dashboard.theme": "Thème",
  "dashboard.noTheme": "Non sélectionné",
  "dashboard.visibility.indexed": "Autoriser l’indexation",
  "dashboard.visibility.unlisted": "Accessible par lien",
  "dashboard.visibility.indexedNote": "Peut apparaître dans les résultats de recherche",
  "dashboard.visibility.unlistedNote": "Reste visible pour toute personne ayant le lien direct",
  "dashboard.snapshot.ready": "Cache prêt",
  "dashboard.snapshot.failed": "Repli D1",
  "dashboard.snapshot.none": "Non généré",
  "dashboard.snapshot.readyNote": "Instantané public écrit sur KV",
  "dashboard.snapshot.failedNote": "La page publique fonctionne toujours via la solution de secours D1",
  "dashboard.snapshot.noneNote": "Aucun instantané n'est disponible pour la version actuellement publiée",
  "invite.title": "Invitez des amis à la bêta publique",
  "invite.remaining": "Les invitations {remaining} / {quota} sont parties ce mois-ci.",
  "invite.generateFailed": "Impossible de générer l'invitation.",
  "invite.generated": "{count} codes d'invitation générés. Ils ne sont affichés que cette fois-ci.",
  "invite.quotaUsed": "Quota d'invitation mensuel utilisé.",
  "invite.generating": "Générateur...",
  "invite.generate": "Générer les {count} restants",
  "invite.batchTitle": "{count} codes générés maintenant",
  "invite.copyAll": "Copier tous les codes",
  "invite.copiedAll": "Tous les codes ont été copiés",
  "invite.copyMessage": "Copier le message",
  "invite.messageCopied": "Message copié",
  "invite.share": "Partager",
  "invite.shared": "La feuille de partage est ouverte.",
  "invite.shareFallback": "Le partage direct n'est pas disponible ; le message a été copié.",
  "invite.shareFailed": "Impossible de partager. Copiez plutôt le message.",
  "invite.shareMessage": "J'utilise 30s.to pour créer une présentation personnelle de 30 secondes. Je vous invite à essayer.\n\nCodes d'invitation :\n{codes}\n\nOuvrez {url} pour commencer.",
  "invite.recentAria": "État d'utilisation des invitations",
  "invite.statusTitle": "État d'utilisation",
  "invite.statusSummary": "{active} disponibles · {redeemed} utilisés · {expired} expirés · {revoked} révoqués",
  "invite.status.revoked": "Révoqué",
  "invite.status.redeemed": "Utilisé",
  "invite.status.expired": "Expiré",
  "invite.status.active": "Disponible",
  "invite.copy": "Copie",
  "invite.copied": "Copié",
  "invite.showOnce": "Affiché une seule fois",
  "invite.expiryUnknown": "Expiration inconnue",
  "invite.expiresAt": "Expire le {date}",
  "management.handlePending.title": "Changement d'adresse en attente",
  "management.handlePending.description": "L'adresse publique actuelle est toujours {publishedAddress}. La publication active {draftAddress}.",
  "management.handlePending.next": "Publiez les modifications avant que {draftAddress} ne devienne l'adresse publique.",
  "management.dirty.title": "Modifications non publiées",
  "management.dirty.description": "Votre brouillon n’a pas été publié sur la page publique.",
  "management.dirty.next": "Publiez les modifications pour synchroniser la page publique avec ce brouillon.",
  "management.published.title": "Publié",
  "management.published.description": "La page publique est à jour.",
  "management.published.next": "La page publique est synchronisée. Continuez l'édition lorsque vous souhaitez l'ajuster.",
  "management.unpublished.title": "Inédit",
  "management.unpublished.description": "Cette introduction n’est toujours enregistrée qu’en tant que brouillon.",
  "management.unpublished.next": "Publiez-le avant que d’autres personnes puissent visiter l’adresse publique.",
  "management.empty.title": "Pas encore d'introduction",
  "management.empty.description": "Choisissez une adresse et rédigez une introduction de 30 secondes.",
  "management.empty.next": "Créez d’abord un brouillon. Les contrôles de pré-publication restent dans l'éditeur.",
  "management.publish.create": "Publier l'introduction",
  "management.publish.update": "Publier les modifications",
  "abuse.kicker": "Confiance et sécurité",
  "abuse.title": "Page de rapport",
  "abuse.copy": "Les rapports sont utilisés uniquement à des fins d'examen de la sécurité. Votre identité n'est pas publique.",
  "abuse.missingHandle": "Cible du rapport manquante.",
  "abuse.done": "Rapport reçu. Nous l'examinerons bientôt.",
  "abuse.failed": "La soumission a échoué. Réessayez plus tard.",
  "abuse.reason.spam": "Courrier indésirable",
  "abuse.reason.impersonation": "Imitation",
  "abuse.reason.abuse": "Harcèlement ou haine",
  "abuse.reason.illegal": "Contenu illégal",
  "abuse.reason.other": "Autre problème",
  "abuse.submitBusy": "Envoi…",
  "abuse.submit": "Soumettre le rapport",
  "terms.title": "Conditions d'utilisation",
  "privacy.title": "Avis de confidentialité",
  "validation.handle.required": "Entrez un handle.",
  "validation.handle.invalid": "L’identifiant doit contenir 4 à 24 lettres minuscules non accentuées.",
  "validation.handle.reserved": "Cette adresse publique n’est pas disponible. Essayez-en une autre.",
  "validation.handle.unavailable": "Cette adresse publique n’est pas disponible. Essayez-en une autre.",
  "validation.handle.frozen": "Cette adresse publique n’est pas disponible. Essayez-en une autre.",
  "validation.handle.protected": "Cette adresse publique n’est pas disponible. Essayez-en une autre.",
  "validation.handle.checkFailed": "Nous n'avons pas pu confirmer cette adresse.",
  "validation.handle.changeLimit": "Vous ne pouvez modifier votre adresse publique qu'une fois tous les 30 jours.",
  "validation.displayName.required": "Le nom ou le pseudo est requis.",
  "validation.identity.required": "Une identité sur une seule ligne est requise.",
  "validation.tags.range": "Ajoutez 1 à 5 balises.",
  "validation.links.limit": "Vous pouvez ajouter jusqu’à {limit} liens indépendants.",
  "validation.links.empty": "Pas encore de liens. Vous pouvez ajouter un profil social, une page de réservation ou une méthode de contact.",
  "validation.input.tooLong": "La saisie est limitée à {limit} caractères.",
  "validation.body.placeholder": "Le texte contient encore {detail}. Remplacez cet élément par un contenu réel ou supprimez-le.",
  "validation.body.oldTemplate": "l’ancien modèle de texte",
  "validation.body.readingTime": "La lecture est estimée à {seconds} secondes. Raccourcissez-la à {maximum} secondes maximum.",
  "validation.body.readingTimeLong": "La lecture est estimée à {seconds} secondes, au-delà des {recommended} secondes recommandées, mais la publication reste possible.",
  "validation.body.readingTimeShort": "La lecture est estimée à {seconds} secondes. Ajoutez du contenu pour atteindre au moins {minimum} secondes.",
  "validation.markdown.h1": "# les titres au niveau de la page ne sont pas pris en charge",
  "validation.markdown.deepHeading": "### et les titres plus profonds ne sont pas pris en charge",
  "validation.markdown.image": "La syntaxe de l'image n'est pas prise en charge",
  "validation.markdown.codeBlock": "Les blocs de code ne sont pas pris en charge",
  "validation.markdown.taskList": "Les listes de tâches ne sont pas prises en charge",
  "validation.markdown.table": "Les tableaux ne sont pas pris en charge",
  "validation.markdown.footnote": "Les notes de bas de page ne sont pas prises en charge",
  "validation.markdown.html": "HTML et les intégrations ne sont pas pris en charge",
  "validation.markdown.commentUnclosed": "Le commentaire n’a pas de marqueur de fin -->",
  "validation.markdown.commentStrayClose": "Le commentaire n’a pas de marqueur de début <!--",
  "validation.markdown.commentNested": "Les commentaires <!-- --> imbriqués ne sont pas pris en charge",
  "validation.markdown.nestedHeading": "Les titres de section doivent être à la racine du document",
  "validation.markdown.setextHeading": "Les titres Setext ne sont pas pris en charge",
  "validation.markdown.headingInline": "Les titres de section ne peuvent contenir que du texte brut",
  "validation.markdown.frontmatter": "Le frontmatter n’est pas pris en charge",
  "validation.markdown.indentedCode": "Les blocs de code indentés ne sont pas pris en charge ; utilisez un bloc clôturé",
  "validation.markdown.codeFenceUnclosed": "La clôture du bloc de code est manquante",
  "validation.markdown.codeLanguage": "Le langage accepte 1 à 32 lettres, chiffres, _, + ou -",
  "validation.markdown.listDepth": "Les listes acceptent jusqu’à trois niveaux",
  "validation.markdown.tableSize": "Les tableaux acceptent jusqu’à 6 colonnes et 20 lignes",
  "validation.markdown.linkProtocol": "Les liens du corps acceptent uniquement HTTPS et les e-mails",
  "validation.link.unsupportedType": "Ce type de lien n’est pas encore pris en charge. Choisissez un lien vers un site web, une plateforme ou une page de réservation.",
  "validation.link.labelRequired": "Le nom du lien ne peut pas être vide.",
  "validation.link.providerRequired": "Choisissez une plateforme de réservation.",
  "validation.link.valueRequired": "{label} ne peut pas être vide.",
  "validation.link.httpsOnly": "Les liens prennent uniquement en charge https://.",
  "validation.link.invalid": "Entrez un lien valide.",
  "validation.link.validEmail": "Entrez un email valide.",
  "validation.link.validGithub": "Entrez un identifiant GitHub valide.",
  "validation.link.validBilibili": "Entrez un Bilibili UID valide.",
  "validation.link.validXiaohongshu": "Entrez un lien de profil Xiaohongshu valide.",
  "validation.link.validGoogleCalendar": "Entrez un lien de réservation Google Calendar valide.",
  "validation.link.validMicrosoftBookings": "Entrez un lien Microsoft Bookings valide.",
  "validation.theme.proRequired": "La publication de ce thème nécessite 30s Pro.",
  "validation.link.validHubSpot": "Entrez un lien HubSpot Meetings valide.",
  "validation.account.banned": "Ce compte ne peut pas publier pour le moment.",
  "validation.account.login": "Veuillez d'abord vous connecter.",
  "validation.account.invite": "Activez d'abord votre compte avec un code d'invitation.",
  "validation.publish.failed": "La publication a échoué. Réessayez plus tard.",
  "validation.turnstile.required": "Terminez la vérification de sécurité.",
  "validation.report.missing": "La page à signaler est manquante.",
  "validation.report.reason": "Choisissez un motif de signalement.",
  "validation.report.notReportable": "Cette page ne peut pas être signalée pour le moment.",
  "common.listSeparator": ",",
  "dashboard.section.status": "Statut",
  "dashboard.section.performance": "Performances",
  "dashboard.fullAnalytics": "Afficher les analyses complètes",
  "dashboard.shareCard": "Partager la carte",
  "dashboard.timestamp.notPublished": "Non publié",
  "dashboard.timestamp.notEdited": "Non édité",
  "dashboard.timestamp.published": "Publié {date} UTC",
  "dashboard.timestamp.edited": "Modifié {date} UTC",
  "upgrade.publishTheme": "Publier {theme}",
  "upgrade.copy": "Votre sélection est enregistrée et reste entièrement prévisualisable. Après le passage à Pro, vous pourrez publier sans recommencer vos modifications.",
  "upgrade.benefit.themes": "Publiez chaque thème premium",
  "upgrade.benefit.analytics": "Voir le temps de lecture et l'achèvement",
  "upgrade.benefit.cards": "Cartes thématiques synchronisées avec les réseaux sociaux OG",
  "upgrade.seePro": "Voir 30s Pro",
  "upgrade.keepEditing": "Continuer à éditer",
  "pro.meta.title": "30s Pro — Exprimez-vous",
  "pro.meta.description": "Des thèmes premium, des analyses de qualité de lecture et des cartes de partage qui font que votre introduction de 30 secondes vous ressemble davantage.",
  "pro.title": "Exprimez pleinement qui vous êtes.",
  "pro.intro": "Toujours 30 secondes à lire. Pro enrichit votre expression, rend les retours plus clairs et prépare vos supports à partager.",
  "pro.priceAction": "Voir le prix fondateur",
  "pro.summaryAria": "Résumé des avantages Pro",
  "pro.summaryThemes": "thèmes premium",
  "pro.summaryAnalytics": "jours d'analyse",
  "pro.summaryShare": "synchronisé avec votre carte",
  "pro.benefitsKicker": "Outils Pro",
  "pro.benefitsTitle": "De l'expression à l'attention.",
  "pro.benefit.themes.title": "Thèmes premium",
  "pro.benefit.themes.body": "Huit thèmes, dont Terminal. Testez-les tous gratuitement, puis publiez celui de votre choix avec Pro.",
  "pro.benefit.analytics.title": "Qualité de lecture",
  "pro.benefit.analytics.body": "Dépassez le simple nombre de visites : temps de lecture active, taux de lecture complète, progression, tendances à 30, 90 et 365 jours et CTR des liens.",
  "pro.benefit.share.title": "Partagez à votre image",
  "pro.benefit.share.body": "Free propose une carte simple avec votre nom et votre lien. Pro ajoute deux cartes universelles et une carte dédiée à chaque thème. La carte choisie devient aussi votre image OG, avec QR intégré, prête à partager ou télécharger.",
  "pro.benefit.attribution.title": "Place à vous",
  "pro.benefit.attribution.body": "Masquez la signature 30s.to dans le thème, tout en conservant les fonctions indispensables de signalement et de langue.",
  "pro.pricingTitle": "Plus tôt vous arrivez, plus c'est simple.",
  "pro.pricingBody": "Vous gardez le Founding Price tant que l'abonnement reste actif. Après résiliation, toute nouvelle souscription se fait au tarif alors en vigueur.",
  "pro.terminalAria": "Aperçu du thème Terminal Pro",
  "pro.checkout.continuous": "Tarif maintenu tant que vous restez abonné",
  "pro.checkout.intervalAria": "Intervalle de facturation",
  "pro.checkout.monthly": "Mensuel",
  "pro.checkout.yearly": "Annuel",
  "pro.checkout.save": "Économisez 16 $",
  "pro.checkout.periodYear": "année",
  "pro.checkout.periodMonth": "mois",
  "pro.checkout.annualNote": "Soit ${price} par mois, 44 % de moins que l'offre mensuelle.",
  "pro.checkout.monthlyNote": "Payez au mois et résiliez quand vous le souhaitez en fin de période.",
  "pro.checkout.includeThemes": "Tous les thèmes premium",
  "pro.checkout.includeAnalytics": "Qualité de lecture et analyses sur 365 jours",
  "pro.checkout.includeCards": "Cartes thématiques, QR et OG",
  "pro.checkout.includeAttribution": "Masquer l'attribution dans le thème",
  "pro.checkout.manage": "Gérer mon abonnement Pro",
  "pro.checkout.comingSoon": "Paiement bientôt disponible",
  "pro.checkout.signIn": "Connectez-vous pour passer à Pro",
  "pro.checkout.inviteRequired": "Invitation bêta requise",
  "pro.checkout.opening": "Ouverture du paiement sécurisé…",
  "pro.checkout.upgrade": "Passer à 30s Pro",
  "pro.checkout.footnote": "Paiement sécurisé avec Creem. Les taxes sont indiquées avant le règlement ; pas d'essai gratuit et renouvellement automatique.",
  "pro.checkout.unavailable": "Impossible d'ouvrir le paiement pour le moment. Réessayez plus tard.",
  "pro.checkout.networkError": "La connexion a échoué. Réessayez plus tard.",
  "billing.panelAria": "Pro et facturation",
  "billing.plan": "Offre",
  "billing.status.canceling": "Résiliation prévue",
  "billing.status.pastDue": "Paiement en retard",
  "billing.status.active": "Actif",
  "billing.status.free": "Gratuit",
  "billing.yearly": "Annuel",
  "billing.monthly": "Mensuel",
  "billing.basicPlan": "Forfait de base",
  "billing.ends": "Se termine le {date}",
  "billing.renews": "Renouvellement le {date}",
  "billing.graceEnds": "Fin du délai de grâce : {date}",
  "billing.anomaly": "Votre état de facturation nécessite un examen manuel. Contactez support@30s.to.",
  "billing.opening": "Ouverture de la facturation",
  "billing.manage": "Gérer la facturation",
  "billing.upgrade": "Passer à Pro",
  "billing.openingHistory": "Ouverture de l'historique…",
  "billing.viewHistory": "Voir l'historique de facturation",
  "billing.portalUnavailable": "La gestion de la facturation est temporairement indisponible.",
  "billing.networkError": "La connexion réseau a échoué. Veuillez réessayer.",
  "billingReturn.kicker": "30s Pro · Confirmation du paiement",
  "billingReturn.activeTitle": "Pro est maintenant actif",
  "billingReturn.failedTitle": "Le paiement n'est pas encore confirmé",
  "billingReturn.waitingTitle": "Confirmation de votre paiement",
  "billingReturn.failedCopy": "Votre paiement est peut-être encore en cours de synchronisation. Vérifiez à nouveau le tableau de bord plus tard ; l'accès n'est jamais accordé à partir de la seule page de retour.",
  "billingReturn.waitingCopy": "Nous vérifions votre abonnement auprès du prestataire de paiement. Gardez cette page ouverte.",
  "billingReturn.back": "Retour au tableau de bord",
  "analytics.kicker": "30s Pro · Analyses",
  "analytics.nav": "Analyses",
  "analytics.title": "De la visite à la lecture complète.",
  "analytics.copy": "Suivez le parcours de la visite à la lecture complète et aux clics, sans pister les personnes. Les dates et la déduplication sont en UTC.",
  "analytics.rangeAria": "Plage de dates",
  "analytics.days": "{count} jours",
  "analytics.uniqueVisitors": "Visiteurs uniques",
  "analytics.rangeTotal": "Total sur {count} jours",
  "analytics.averageReading": "Temps de lecture active moyen",
  "analytics.activeReadingNote": "Temps pendant lequel la page est visible et active",
  "analytics.completionRate": "Taux d'achèvement",
  "analytics.completedVisitors": "{count} visiteurs ont terminé la lecture",
  "analytics.overallCtr": "CTR global",
  "analytics.engagedVisitors": "{count} visiteurs ont interagi",
  "analytics.trafficTrend": "Tendance du trafic",
  "analytics.dailyTrendAria": "Tendance quotidienne des visiteurs uniques",
  "analytics.readingCompletion": "Achèvement de la lecture",
  "analytics.dailyMaximum": "Visiteurs/maximum quotidien",
  "analytics.visitorCount": "{count} visiteurs",
  "analytics.topLinks": "Principaux liens",
  "analytics.uniqueClickers": "Personnes ayant cliqué",
  "analytics.linkTrendAria": "Tendance quotidienne pour {label}",
  "analytics.noInteractions": "Aucune interaction de lien pour l'instant.",
  "analytics.audienceOverview": "Aperçu du public",
  "analytics.pageLevel": "Niveau de la page",
  "analytics.referrers": "Sources de trafic",
  "analytics.devices": "Appareils",
  "analytics.countries": "Pays",
  "analytics.noData": "Aucune donnée pour l'instant",
  "analytics.durationSeconds": "{seconds} s",
  "analytics.durationMinutes": "{minutes} min {seconds} s",
  "share.card": "Carte de partage",
  "share.variant.classic": "Classique",
  "share.variant.classicNote": "Calme",
  "share.variant.contact": "Indice",
  "share.variant.contactNote": "Structuré",
  "share.variant.theme": "Édition {theme}",
  "share.variant.themeNote": "Thème",
  "share.variant.universal": "Universel",
  "share.saveFailed": "Impossible d'enregistrer",
  "share.styleUpdated": "Style mis à jour",
  "share.networkError": "La connexion réseau a échoué",
  "share.linkCopied": "Lien copié",
  "share.copyFailed": "Échec de la copie",
  "share.text": "Mon introduction de 30 secondes",
  "share.failed": "Impossible de partager",
  "share.published": "Publié",
  "share.draft": "Brouillon",
  "share.style": "Style",
  "share.alt": "Carte de partage de {name}",
  "share.publishFirst": "Publier pour partager",
  "share.action": "Partager",
  "share.download": "Télécharger",
  "share.openPublicPage": "Ouvrir la page publique",
  "share.chooseStyle": "Choisissez le style de la carte",
  "share.close": "Fermer",
  "share.cardStyle": "Style de carte",
  "share.chooseOne": "Choisissez un style",
  "share.chooseStyleAria": "Choisissez le style de carte de partage",
  "share.saving": "Enregistrement…",
  "validation.body.placeholderDetail.legacyTemplate": "l'ancien modèle de texte",
  "validation.body.placeholderDetail.ellipsis": "l'espace réservé `...`",
  "validation.body.placeholderDetail.sampleLink": "l'exemple de lien `https://example.com`",
  "validation.body.placeholderDetail.projectName": "l'espace réservé `项目名`",
  "validation.body.placeholderDetail.instruction": "texte d'instruction du modèle",
  "analytics.gate.signInTitle": "Connectez-vous pour voir les statistiques",
  "analytics.gate.signInCopy": "Vos données de visites et d’interactions restent en sécurité dans le tableau de bord.",
  "analytics.gate.signInAction": "Se connecter",
  "analytics.gate.proTitle": "Découvrez si votre présentation est lue jusqu’au bout.",
  "analytics.gate.proCopy": "Consultez le temps de lecture actif, le taux de lecture complète, la progression, les tendances sur 30, 90 et 365 jours et le CTR des liens.",
  "analytics.gate.proAction": "Découvrir 30s Pro",
  "analytics.gate.emptyTitle": "Les données apparaîtront après la publication.",
  "analytics.gate.emptyCopy": "Terminez d’abord votre présentation de 30 secondes. Après sa publication, vous verrez les tendances de visites et d’interactions.",
  "analytics.gate.emptyAction": "Commencer",
  "analytics.gate.privacyNote": "Agrégation quotidienne UTC · Déduplication anonyme · Aucune adresse IP brute conservée",
  "handleEdit.previous": "Anciennes adresses protégées",
  "handleEdit.deadlines": "Redirection jusqu’au {redirectDate} ; protection jusqu’au {releaseDate}.",
  "handleEdit.usePrevious": "Utiliser cette adresse",
  "handleEdit.reclaimAvailable": "Vous pouvez récupérer cette ancienne adresse.",
  "publish.handleReclaimed": "La récupération compte comme un changement d’adresse. L’adresse actuelle bénéficiera de 30 nouveaux jours de redirection et de 180 jours de protection."
}
